export const defaultMemberPasswordResetFormData = {
    password: ''
};
